import * as Yup from 'yup';

import { addressValidationSchema } from 'src/common/validation/address';
import type { IAddress } from 'src/types/IAddress';
import type { ICustomerLeadProduct } from 'src/types/customers/ICustomerLeadProduct';

export type ICustomerLeadProductAddressTabFormValues = {
  address: IAddress;
};

export const customerLeadProductContactTabValidationSchema =
  Yup.object<ICustomerLeadProductAddressTabFormValues>().shape({
    address: addressValidationSchema,
  });

export function toCustomerLeadProductAddressTabInitialValues(
  customerLeadProduct: ICustomerLeadProduct,
  addressFieldName: Extract<keyof ICustomerLeadProduct, 'shippingAddress' | 'billingAddress'>
): ICustomerLeadProductAddressTabFormValues {
  return {
    address: customerLeadProduct[addressFieldName],
  };
}
